export interface SubmissionAttempt {
  signature: string;
  id: string;
}

// Reuses the previous id when the signature is unchanged (a retry), else mints a fresh one so an edit isn't mistaken for a replay
export const resolveSubmissionAttempt = (
  signatureParts: unknown,
  lastAttempt: SubmissionAttempt | undefined
): SubmissionAttempt => {
  const signature = JSON.stringify(signatureParts);
  return lastAttempt?.signature === signature ? lastAttempt : { signature, id: crypto.randomUUID() };
};
